import checkoutAddNewAddressHtml from './checkoutaddnewaddress.component.html';
import './checkoutaddnewaddress.component.scss';

class CheckoutAddNewAddressController {
    constructor($scope, $http, $window, SnackbarService, CheckoutService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.SnackbarService = SnackbarService;
        this.service = CheckoutService;

        this.loading = false;
        this.showAllErrors = false;

        this.data = {
            id: '',
            addressName: '',
            firstName: '',
            lastName: '',
            companyName: '',
            taxNumber: '',
            noTaxNumber: 0,
            icoNumber: '',
            address: '',
            city: '',
            zipCode: '',
            country: '',
            invoice: 0
        };
    }

    get countries() {
        switch (this.type) {
            case 0:
                return this.service.shopPaymentCountries;
            case 1:
                return this.service.shopShipmentCountries;
            default:
                return this.service.shopPaymentCountries;
        }

        return [];
    }

    get isValid() {
        return this.form && this.form.$valid;
    }

    get isTaxNumberRequired() {
        return parseInt(this.data.invoice) === 1 &&
            this.service.shopId !== 2 &&
            this.service.shopId !== 4 &&
            (this.service.shopId !== 5 || this.service.shopId === 5 && parseInt(this.data.noTaxNumber) === 0);
    }

    $onInit() {
        this.data.type = parseInt(this.type);
        this.data.country = this.shopCountry;

        this.$scope.$watch(() => this.type, () => {
            this.data.type = parseInt(this.type);
            this.data.country = this.shopCountry;
        });

        if (this.service.shopId === 6) {
            this.data.invoice = 1;
        }

        this.$scope.$watch(() => this.service.shopId, (newVal) => {
            if (newVal === 6) {
                this.data.invoice = 1;
            }
        });

        this.$scope.$watch(() => this.address, () => {
            if (!this.address) {
                return;
            }

            this.data = this.service.transformAddress(this.address);

            if (this.data.companyName || this.data.taxNumber) {
                this.data.invoice = 1;
            } else {
                this.data.invoice = 0;
            }
        });

        this.$scope.$watch(() => this.data, (newVal, oldVal) => {
            if (this.$scope.$ctrl.form) {
                for (let $$control of this.$scope.$ctrl.form.$$controls) {
                    if ($$control.$name === 'taxNumber') {
                        $$control.$setDirty();
                        $$control.$validate();
                    }
                }
            }
            if (newVal.invoice !== oldVal.invoice && newVal.invoice === '0') {
                this.data.taxNumber = null;
            }
        }, true);

        this.$scope.$watch(() => this.data.noTaxNumber, (newVal, oldVal) => {
            if (parseInt(newVal) === 1) {
                this.data.taxNumber = null;
            }
        }, true);

        this.$scope.taxNumberPattern = (() => {
            let patterns = {
                CZ: /^CZ\d{8,10}$/,            // Czechy
                AT: /^(ATU)[0-9]{8}$/,         // Austria (musi mieć "U")
                BE: /^BE[0-9]{10}$/,           // Belgia
                DK: /^DK[0-9]{8}$/,            // Dania
                NL: /^NL[0-9]{9}B[0-9]{2}$/,   // Holandia
                LU: /^LU[0-9]{11}$/,           // Luksemburg
                DE: /^DE[0-9]{9}$/,            // Niemcy
                IT: /^IT[0-9]{11}$/,           // Włochy
                EU: /^[A-Z]{2}[A-Z0-9]{5,18}$/ // Uniwersalny wzór UE
            };

            return {
                test: (value) => {
                    switch (this.service.shopId) {
                        case 4: // CZ (pattern: CZ lub EU)
                            return patterns.CZ.test(value) || patterns.EU.test(value);
                        case 5: // AT
                            return this.data.country === 'AT' ? patterns.AT.test(value) : true;
                        case 6: // EU
                            return patterns[this.data.country]
                                ? patterns[this.data.country].test(value)
                                : false;
                        default:
                            return true;
                    }
                }
            };
        })();
    }

    getAddressPattern() {
        return '^(?=.*[A-Za-z])(?=.*\\d).+$';
    }

    save() {
        this.showAllErrors = true;
        this.form.$$setSubmitted();

        if (!this.isValid) return;

        if (this.data.type == 2) {
            const id = null;

            this.$scope.$parent.$ctrl.close({id, data: this.data});

            return;
        }

        this.loading = true;

        let endpoint = this.data.id ? '/ajax/checkout/edit-address' : '/ajax/checkout/add-new-address';

        if (!this.data.hasOwnProperty('noTaxNumber')) {
            this.data.noTaxNumber = 0;
        }

        this.$http.post(
            endpoint,
            this.data
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.message) {
                    const message = response.data.message;
                    this.SnackbarService.add(message.content, 'error', true, 3000);
                    return;
                }

                const id = response.data.data.addressId;

                this.$scope.$parent.$ctrl.close({id, data: this.data});
            },
            (error) => {
                this.loading = false;

                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);
            }
        );
    }

    close() {
        this.$scope.$parent.$ctrl.close();
    }
}

let checkoutAddNewAddressComponent = {
    bindings: {
        type: '<',
        address: '<',
        shopCountry: '<'
    },
    template: checkoutAddNewAddressHtml,
    controller: CheckoutAddNewAddressController
}

export default checkoutAddNewAddressComponent;
